import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {getPaymentDataFailure, getPaymentDataSuccess} from "features/pages/payment/reducer";
import {Payment} from "mapping/payment";

export function* getPaymentDataSaga({payload}) {
    const {type, resource_id} = payload;
    try {
        const apiToCall = type === "video" ? api.singleVideoApi : api.singleDirectoryApi;
        const data = yield call([api, apiToCall], resource_id);
        const payment = type === "video" ? Payment.fromVideo(data) : Payment.fromDirectory(data);
        yield put(getPaymentDataSuccess(payment));
    } catch (e) {
        console.log(e);
        yield put(getPaymentDataFailure(getErrorFromMessage(e)));
    }
}